/**
 * Created by zhengyf on 2018.3.9.
 */

;(function () {

    RfqLoadAccInfoFactory.$inject = ['request', '$q'];
    angular
        .module('DSSXAPP')
        .factory('rfqLoadAccInfoFactory', RfqLoadAccInfoFactory)

    function RfqLoadAccInfoFactory(request, $q) {

        function AccInfoLoader() {
            this.waitList = [];
            this.accInfo = {};
            this.pending = null;
        }

        /**
         * AccInfoLoader.start
         * @param params {string} 'rfqCustomSearchTexts', 'numQuoteEquity'
         * @param isWait {boolean}
         * @returns {Promise}
         */
        AccInfoLoader.prototype.start = function (params, isWait) {
            var deferred = $q.defer();

            this.waitList.push({
                params: params,
                isWait: isWait,
                pending: deferred
            });

            this.handleMoreRequest(isWait);

            return deferred.promise;
        }

        AccInfoLoader.prototype.load = function (params) {

            return request.get('/usr/api/loadAccInfo', params, true)
                .then(callback, errCallback);

            function callback(res) {

                var accInfo = {};

                accInfo.customizeSearchKey = DSSX.util.safe(res, 'data.accInfo.rfqCustomSearchTexts', []);
                accInfo.quoteEquityNum = DSSX.util.safe(res, 'data.accInfo.numQuoteEquity', 0);

                return accInfo;
            }

            function errCallback(error) {

                DSSX.dialog.err(error, {
                    moduleName: 'load-account-info.js',
                    funcName: 'loadAccInfo',
                    text: 'loadAccInfo failed'
                });

                var accInfo = {};

                accInfo.customizeSearchKey = [];
                accInfo.quoteEquityNum = 0;

                return accInfo;
            }
        }

        AccInfoLoader.prototype.handleMoreRequest = function (isWait) {
            var self = this;
            var paramsList = [];
            for (var i = 0; i < this.waitList.length; i++) {
                paramsList.push(this.waitList[i].params);
            }

            // 是否需要请求多个信息
            if (this.waitList.length > 1) {
                this.load({
                    returnField: paramsList.join()
                }).then(function (res) {
                    self.accInfo.customizeSearchKey = res.customizeSearchKey;
                    self.accInfo.quoteEquityNum = res.quoteEquityNum;

                    for (var i = 0; i < self.waitList.length; i++) {
                        var info = self.waitList[i];
                        info.pending.resolve(self.accInfo);
                    }

                    self.waitList = [];
                });
            }

            if (this.waitList.length === 1 && !isWait) {
                this.load({
                    returnField: paramsList.join()
                }).then(function (res) {

                    self.accInfo.customizeSearchKey = res.customizeSearchKey;

                    for (var i = 0; i < self.waitList.length; i++) {
                        var info = self.waitList[i];
                        info.pending.resolve(self.accInfo);
                    }

                    self.waitList = [];
                });
            }
        }

        return new AccInfoLoader();

    }

})();
